import React, { useState } from 'react';
import { Section } from './Section';
import { BookOpen, CheckCircle2, ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const tomos = [{
  num: '1',
  title: 'Stretching Base',
  classes: '8+ clases',
  desc: 'Fundamentos de la elongación, respiración, cadenas musculares y flexibilidad inicial. La base que todo profe necesita dominar.'
}, {
  num: '2',
  title: 'Flexibilidad Profunda',
  classes: '10 clases',
  desc: 'Técnicas avanzadas de elongación sostenida, FNP y liberación miofascial. Para alumnos que quieren ir más allá.'
}, {
  num: '3',
  title: 'Movilidad Funcional',
  classes: '10 clases',
  desc: 'Secuencias de movilidad articular dinámica. Ideal para alumnos que quieren moverse mejor en su vida cotidiana.'
}, {
  num: '4',
  title: 'Stretching con Elementos',
  classes: '10 clases',
  desc: 'Trabajo de precisión con foam roller, bandas y pelota. Activa lo que las manos vacías no alcanzan.'
}, {
  num: '5',
  title: 'Stretching Suave',
  classes: '10 clases',
  desc: 'Protocolo de seguridad completo para adultos mayores, movilidad articular suave y funcionalidad cotidiana.'
}, {
  num: '6',
  title: 'Full Relax',
  classes: '10 clases',
  desc: 'El repertorio completo de stretching de alta intensidad y relajación profunda para alumnos avanzados. El cierre perfecto de cualquier sesión.',
  star: true
}];
const includes = ['Planificación lista para usar desde el primer día', 'Clases con objetivo, desarrollo y cierre', 'Cueings listos para decir palabra por palabra', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Checklist pre y durante la clase', 'Planillas de seguimiento de alumnos', 'Adaptaciones para grupos heterogéneos', '100% adaptado al contexto formativo argentino'];
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <Section className="bg-brand-dark !py-8 md:!py-12" data-id="element-360" data-mp="282acy1n5cs3c">
      <div className="text-center mb-5 md:mb-8" data-id="element-361" data-mp="200j9x1fkm9f6">
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-1.5" data-id="element-362" data-mp="1vy65cgck8hjz">
          LOS 6 TOMOS
        </h2>
        <p className="text-sm md:text-lg text-brand-accent font-medium" data-id="element-363" data-mp="29ygy5oxfk67s">
          Para profes de Stretching de todos los niveles y enfoques
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-2 mb-6 md:mb-10" data-id="element-364" data-mp="25177y727vqiw">
        {tomos.map((tomo, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-brand-light rounded-xl border border-white/5 overflow-hidden transition-colors" style={isOpen ? {
          borderColor: 'rgba(45,212,191,0.3)'
        } : {}} data-id="element-365" data-mp="2evz8njr3ithw" data-mpi={i}>
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between px-4 py-3 md:px-5 md:py-3.5 text-left focus:outline-none group" data-id="element-366" data-mp="2nqdktdgbxnws">
                <div className="flex items-center gap-3" data-id="element-367" data-mp="2xnrzb7ip02mg">
                  <span className="bg-brand-dark text-brand-accent font-bold px-2.5 py-0.5 rounded-lg text-xs border border-brand-accent/20 whitespace-nowrap" data-id="element-368" data-mp="2xpcvt2okhvmy">
                    {tomo.star ? '⭐ T' : 'T'}
                    {tomo.num}
                  </span>
                  <span className="text-white font-display font-bold text-sm md:text-base" data-id="element-369" data-mp="37bx9r0320nw9">
                    {tomo.title}
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-370" data-mp="2xlcbxev7fnee">
                  <span className="text-gray-400 text-xs font-medium hidden sm:flex items-center" data-id="element-371" data-mp="2xk1bnp0ywxs1">
                    <BookOpen className="w-3.5 h-3.5 mr-1" data-id="element-372" data-mp="32dc9j0nsy47t" />
                    {tomo.classes}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-373" data-mp="2oitcz5ujhuxf">
                    <ChevronDownIcon className="w-4 h-4 text-gray-400 group-hover:text-brand-accent transition-colors" data-id="element-374" data-mp="2enrn27sfwots" />
                  </motion.div>
                </div>
              </button>

              <AnimatePresence initial={false} data-id="element-375" data-mp="3mv5p78wu7j6b">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-376" data-mp="3hxmcidfsfegh">
                    <div className="px-4 pb-3.5 md:px-5 md:pb-4 pt-0" data-id="element-377" data-mp="33652lrdfnli4">
                      <div className="flex items-center gap-2 mb-1.5 sm:hidden" data-id="element-378" data-mp="2z5bfv1bq8cqt">
                        <BookOpen className="w-3.5 h-3.5 text-gray-400" data-id="element-379" data-mp="2u8ky89k9x93a" />
                        <span className="text-gray-400 text-xs font-medium" data-id="element-380" data-mp="2p98bdotek20p">
                          {tomo.classes}
                        </span>
                      </div>
                      <p className="text-gray-300 text-sm leading-relaxed" data-id="element-381" data-mp="nhc1skqsp28k">
                        {tomo.desc}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <div className="bg-gradient-to-br from-brand-light to-brand-dark p-4 md:p-8 rounded-xl border border-brand-accent/20 max-w-3xl mx-auto shadow-2xl" data-id="element-382" data-mp="zyd2b5s4gj0r">
        <h3 className="text-lg md:text-xl font-display font-bold text-white mb-3 md:mb-4 text-center" data-id="element-383" data-mp="19phejxqexprw">
          Cada tomo incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-2" data-id="element-384" data-mp="c3juhvwdxcdu">
          {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-385" data-mp="h1lkz1w54dzc" data-mpi={i}>
              <CheckCircle2 className="w-3.5 h-3.5 text-brand-accent mr-2 flex-shrink-0 mt-0.5" data-id="element-386" data-mp="lzn4fnxhafbc" />
              <span className="text-gray-200 text-xs md:text-sm" data-id="element-387" data-mp="qzsq8nh2h7li">{item}</span>
            </div>)}
        </div>
      </div>
    </Section>;
}